import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  cardContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    height: 'calc(100% - 60px)',
    zIndex: 2,
  },
  cardContainerNonFullscreen: {
    backgroundColor: '#EDEDF6',
    width: 'calc(100% - 40px)',
  },
  cardContainerFullscreen: {
    width: 'calc(100% - 40px)',
  },
  cardPreview: {
    position: 'relative',
    backgroundColor: 'rgba(219, 220, 229, 0.28)',
    zIndex: 2,
    display: 'flex',
    justifyContent: 'center',
    transition: '0.5s ease-in-out',
    overflow: 'auto',
    width: '100%',
  },
  cardPreviewNonFullscreen: {
    borderTop: 'solid 1px rgba(44, 45, 62, 0.3)',
    borderLeft: 'solid 1px rgba(44, 45, 62, 0.3)',
  },
  cardPreviewFullscreen: {
    height: 'calc(100vh - 1px)',
  },
  customTooltip: {
    backgroundColor: '#2C2D3E',
  },
  customArrow: {
    color: '#2C2D3E',
  },
  card: {
    display: 'flex',
    height: 'max-content',
    left: '10px',
    borderRadius: '4px',
    transition: 'width 0.5s ease-in-out',
  },
  fullscreenIcon: {
    position: 'absolute',
    top: '10px',
    zIndex: 10,
    cursor: 'pointer',
  },
  fullscreenIconFullscreen: {
    position: 'absolute',
    top: '15px',
    zIndex: 20,
    cursor: 'pointer',
  },
}));
